import openApis from '../data/openapi/apis'

export default [{
  title: 'openapi',
  type: 'openapi',
  subMenus: openApis
}]



// WEBPACK FOOTER //
// ./src/data/apis.js